import React from 'react';
import roles from 'helpers/roles';
import { withTranslation } from 'react-i18next';
import getReportFileName from 'helpers/getReportFileName';

import BaseBrandReport from './BaseBrandReport';

class OrderedDiets extends React.Component {
  render() {
    const { t } = this.props;
    const title = t('common.mainMenu.reportOrderedDiets');

    return (
      <BaseBrandReport
        title={title}
        excelUrl="/reports/ordered-diets"
        mimeType="application/vnd.ms-excel"
        fileName={getReportFileName(title)}
        role={roles.ROLE_SHOW_REPORT_ACTIVE_DIET}
        pdfAvailable={false}
        excelAvailable={true}
        previewXlsxAvailable={true}
        dateType={['range', 'ordered']}
        archiveReportNames={['ORDERED_DIETS']}
        useZoneCategories={true}
      />
    );
  }
}

export default withTranslation()(OrderedDiets);
